import { render } from "./ContentIngredientComposer.vue?vue&type=template&id=12b0ab92&scoped=true"
import script from "./ContentIngredientComposer.vue?vue&type=script&lang=js"
export * from "./ContentIngredientComposer.vue?vue&type=script&lang=js"

import "./ContentIngredientComposer.vue?vue&type=style&index=0&id=12b0ab92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b0ab92"]])

export default __exports__